// extracted by mini-css-extract-plugin
export default {"social_link":"Footer_social_link__+-AQb"};